import React, { useState, useEffect } from "react";
import { apiGet } from "../../services/api";
import "./Pharmacy.css";

interface LowStockItem {
  id: number | string;
  name: string;
  stock_qty?: number;
  threshold?: number;
}

export default function LowStockAlertPanel() {
  const [lowStockAlerts, setLowStockAlerts] = useState<LowStockItem[]>([]);

  useEffect(() => {
    const loadAlerts = async () => {
      try {
        const raw = await apiGet("/api/pharmacy/alerts") as { low_stock?: LowStockItem[] } | null;
        const data = raw ?? {};
        setLowStockAlerts(Array.isArray(data.low_stock) ? data.low_stock : []);
      } catch (e) {
        console.error("Failed to load low stock alerts", e);
        setLowStockAlerts([]);
      }
    };
    loadAlerts();
    const interval = setInterval(loadAlerts, 60000);
    return () => clearInterval(interval);
  }, []);

  if (lowStockAlerts.length === 0) {
    return (
      <div className="low-stock-alert-panel">
        <div className="alert-header">
          <h4>⚠️ Low Stock Alerts</h4>
        </div>
        <div className="alert-empty">✅ All items in stock</div>
      </div>
    );
  }

  return (
    <div className="low-stock-alert-panel">
      <div className="alert-header">
        <h4>⚠️ Low Stock Alerts</h4>
        {lowStockAlerts.length > 0 && <span className="alert-badge">{lowStockAlerts.length}</span>}
      </div>
      <div className="alert-list-scrollable">
        {lowStockAlerts.map((item) => (
          <div
            key={item.id}
            className="alert-item-low-stock"
            style={{
              backgroundColor: "#fef3c7",
              borderLeft: "4px solid #f59e0b",
            }}
          >
            <div className="alert-item-name-black">{item.name}</div>
            <div className="alert-item-detail">
              Stock: {item.stock_qty} (Threshold: {item.threshold})
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
